import { Web3SolanaProgramInteraction } from '@/program/web3';
import { Web3DefaiProgramInteraction } from '@/program/web3DefaiLaunchpad';
import { web3FungibleStake } from '@/program/web3FungStake';
import { Web3MemeLaunchPadProgramInteraction } from '@/program/web3MemeLaunchpad';
import { CoinType } from '@/zustand-store/coin/useCoinStore';

let solanaInstance: any = null;

const web3Meme = new Web3MemeLaunchPadProgramInteraction();
const web3Defai = new Web3DefaiProgramInteraction();
const web3Agent = new Web3SolanaProgramInteraction();

export class Web3SolanaTradingService {
  constructor() {}

  static getInstance(
    type: CoinType,
  ):
    | Web3MemeLaunchPadProgramInteraction
    | Web3DefaiProgramInteraction
    | Web3SolanaProgramInteraction {
    switch (type) {
      case CoinType.AGENT:
        return web3Agent;
      case CoinType.DEFAI:
        return web3Defai;
      case CoinType.MEME:
        return web3Meme;

      default:
        return web3Agent;
    }
  }

  removeInstance() {
    solanaInstance = null;
  }
}
